import { makeAutoObservable, runInAction } from 'mobx'

import { LoadActivityHistoryTask } from '../Tasks/LoadActivityHistoryTask'

import type { ActivityHistoryItem } from '../Helpers/activityHistoryEntries'

/**
 * Стрічка «Історія змін» справи (ADR 041, `SPEC-011` §6); екземпляр — на
 * змонтовану вкладку: шаблон перемонтовує її на кожне відкриття.
 */
export class ActivityHistoryTabStore {
    items: ActivityHistoryItem[] = []
    /** Скільки подій усього — якщо більше, ніж показано, стрічка про це скаже */
    total = 0
    isLoading = false
    /** Запит не вдався: порожня стрічка тоді означала б неправду «змін не було» */
    failed = false

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true })
    }

    async load(uuid: string | undefined): Promise<void> {
        if (!uuid) return

        this.isLoading = true
        this.failed = false

        try {
            const { items, total } = await LoadActivityHistoryTask(uuid)

            runInAction(() => {
                this.items = items
                this.total = total
            })
        } catch {
            runInAction(() => {
                this.items = []
                this.total = 0
                this.failed = true
            })
        } finally {
            runInAction(() => {
                this.isLoading = false
            })
        }
    }
}
